/**
 * Copyright © 2026 Delicious AI, LLC
 */

import {
  FactCheck,
  GridView,
  Insights,
  Label,
  ManageSearch,
  PhotoLibrary,
  PublishedWithChanges,
  Storage,
} from '@mui/icons-material'

import { TFnType } from '@tolgee/react'

import { SidebarItemsType } from '@/types/sidebar'

const buildNavItems = (
  t: TFnType,
  options: { isSuperuser?: boolean } = {},
): {
  title: string
  pages: SidebarItemsType[]
}[] => {
  const labelingSection: SidebarItemsType = {
    href: '',
    icon: Label,
    title: t('sidebar.labeling.title', 'Labeling'),
    id: 'labeling-nav',
    children: [
      {
        href: '/classification',
        icon: PhotoLibrary,
        title: t('sidebar.labeling.classification', 'Classification'),
        id: 'classification-nav',
      },
      {
        href: '/correction',
        icon: PublishedWithChanges,
        title: t('sidebar.labeling.correction', 'Correction'),
        id: 'correction-nav',
      },
      {
        href: '/detection',
        icon: GridView,
        title: t('sidebar.labeling.detection', 'Detection'),
        id: 'detection-nav',
      },
    ],
  }

  const pages: SidebarItemsType[] = [
    {
      href: '/stats',
      icon: Insights,
      title: t('sidebar.stats.title', 'Stats'),
      id: 'stats-nav',
    },
    labelingSection,
    {
      href: '/review',
      icon: FactCheck,
      title: t('sidebar.review.title', 'Review'),
      id: 'review-nav',
    },
  ]

  if (options.isSuperuser) {
    pages.push({
      href: '/explorer',
      icon: ManageSearch,
      title: t('sidebar.labeling.explorer', 'Explorer'),
      id: 'explorer-nav',
    })
    pages.push({
      href: '/crop-review',
      icon: Storage,
      title: t('sidebar.labeling.cropReview', 'Crop Review'),
      id: 'crop-review-nav',
    })
  }

  return [{ title: '', pages }]
}

export default buildNavItems
